import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface Props {
  onBack: () => void;
}

const TermsOfService: React.FC<Props> = ({ onBack }) => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white border-2 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,0.1)] my-8 animate-in fade-in slide-in-from-bottom-4">
      <button 
        onClick={onBack}
        className="flex items-center gap-2 text-gray-500 hover:text-black font-hand mb-6 transition-colors"
      >
        <ArrowLeft size={20} />
        Back to Sketching
      </button>

      <h1 className="text-3xl font-bold font-hand mb-6">Terms of Service</h1>
      <p className="font-hand text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="prose font-sans text-gray-800 space-y-6">
        <section>
          <h2 className="text-xl font-bold mb-2">1. Acceptance of Terms</h2>
          <p>
            By accessing and using LogiSketch, you accept and agree to be bound by the terms and provision of this agreement. 
            If you do not agree to abide by these terms, please do not use this service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">2. Description of Service</h2>
          <p>
            LogiSketch is an AI-powered tool that transforms text inputs into hand-drawn style images. 
            We use third-party AI models (Google Gemini/Imagen) to generate this content.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">3. Credits and Payments</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Pricing:</strong> Credits are purchased in packs (e.g., Starter Pack, Pro Pack). Prices are listed clearly at checkout.</li>
            <li><strong>Usage:</strong> One generation equals one credit. One modification equals one credit.</li>
            <li><strong>Refund Policy:</strong> Since credits invoke costs on our end immediately, <strong>all purchases are final and non-refundable</strong> once any credits from a pack have been used. If you have purchased a pack by mistake and have not used any credits, please contact support within 7 days.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">4. AI Disclaimer</h2>
          <p>
            The images are generated by Artificial Intelligence. We cannot guarantee the accuracy, uniqueness, or quality of any specific generation. 
            You acknowledge that AI may occasionally produce offensive or incorrect results, although we implement safety filters to minimize this.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">5. Intellectual Property</h2>
          <p>
            <strong>Your Content:</strong> You retain ownership of the text prompts you input. 
            Subject to Google's Generative AI terms, you own the images you generate using LogiSketch.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-2">6. Limitation of Liability</h2>
          <p>
            In no event shall LogiSketch be liable for any indirect, incidental, special, consequential or punitive damages, 
            including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the service.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;